export const selectLocales = (root: RootState) => root.i18n.localeList
